<template>
  <div>
    <tci-about-us :title="$t('about.company_access.title')" row_color="white" row_padding="mx-auto pb-6 text-center">
      <v-img :src="backmap[$i18n.locale]" :height="img_height" class="d-none d-sm-flex">
        <v-row align="start" class="fill-height" v-resize="onResize" no-gutters>
          <v-col>
            <v-row class="pa-0 ma-0" v-for="(item,index) in avatar_padding" :key="index">
              <v-card flat :height="item.height" class="py-0 my-0" :style='"padding-left:"+item.padding+"px"' color="transparent" >
                <v-row class="fill-height" align="start">
                  <v-btn v-if="item.imageUrl" :to='"/company-address/"+item.id' fab>
                    <v-avatar size=70 class="pa-0 ma-0"  >
                      <v-img  class="pa-0 ma-0" :src="item.imageUrl"></v-img>
                    </v-avatar>
                  </v-btn>
                </v-row>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-img>
      <v-row align="start" class="fill-height d-flex d-sm-none" v-resize="onResize" >
        <v-list links class="mt-0">
          <v-list-item class="py-2 my-0" v-for="(item,index) in avatar_padding" :key="index">
            <v-list-item-icon v-if="item.imageUrl" class="py-0 my-0">
              <v-btn v-if="item.imageUrl" :to='"/company-address/"+item.id' fab class="pa-0 ma-0">
                <v-avatar size=70 class="pa-0 ma-0"  >
                    <v-img  class="pa-0 ma-0" :src="item.imageUrl"></v-img>
                </v-avatar>
              </v-btn>
            </v-list-item-icon>
            <v-list-item-content v-if="item.name">
              <v-list-item-title>{{ $t(item.name) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>    
      </v-row>
    </tci-about-us>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciAboutUs from "@/components/TciAboutUs.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

import map_zh from '@/assets/companyAccess/chinaMap2.png'
import map_jp from '@/assets/companyAccess/chinamap_jp.png'

export default {
  name: "CompanyAccess",
  components: {
    "tci-about-us": TciAboutUs,
    "tci-contact-footer": TciContactFooter
  },
  data: () => ({
    avatar_size: 60,
    img_height: 700,
    img_width: 700,
    backmap: {
      zh: map_zh,
      ja: map_jp
    },
    avatar_boxs: [{'height':37.5115639318243,'padding':206},
    {'height':49.34391138164784,'padding':107.45622995117947,'imageUrl':require('../assets/companyAccess/city1.png'),id:1,"name":"about.company_access.company_suzhou"},
    {'height':53.41300056934239,'padding':141.59093969888477,'imageUrl':require('../assets/companyAccess/city2.png'),id:1,"name":"about.company_access.company_changzhou"},
    {'height':56.54986858053161,'padding':168.92318018845003,'imageUrl':require('../assets/companyAccess/city3.png'),id:1,"name":"about.company_access.company_shanghai"},
    {'height':93.18165553665386,'padding':188.9759197400574},
    {'height':70,'padding':206,'imageUrl':require('../assets/companyAccess/city5.png'),id:1,"name":"about.company_access.company_shibuya"},
    {'height':34.48188811830718,'padding':206},
    {'height':58.69976741834668,'padding':201.3991763594792,'imageUrl':require('../assets/companyAccess/city6.png'),id:1,"name":"about.company_access.company_tianjin"},
    {'height':56.54986858053161,'padding':188.97591974005744,'imageUrl':require('../assets/companyAccess/city7.png'),id:1,"name":"about.company_access.company_gotanda"},
    {'height':53.41300056934239,'padding':168.92318018845,'imageUrl':require('../assets/companyAccess/city8.png'),id:1,"name":"about.company_access.company_guangzhou"},
    {'height':49.34391138164784,'padding':141.59093969888477,'imageUrl':require('../assets/companyAccess/city9.png'),id:1,"name":"about.company_access.company_shenzhen"},
    {'height':44.41361914167675,'padding':107.45622995117952,'imageUrl':require('../assets/companyAccess/city10.png'),id:1,"name":"about.company_access.company_jinan"},
    ]
  }),
  computed: {
    avatar_padding: function(){
      var avatar_box = [];
      for(var index in this.avatar_boxs){
        if(this.$vuetify.breakpoint.xs&&index==0){
          continue;
        }
        var item  = this.avatar_boxs[index];
        avatar_box.push({'height':item.height,'padding':item.padding+this.img_width/2,'imageUrl':item.imageUrl,id:item.id,name:item.name});
      }
      return avatar_box;
    },
    avatar_box: function(){
      //圆的直径
      var big_r = (109 * this.img_height) / 84;
      //剩下的总弧度
      var all_radian = Math.asin(84/109)*2 ;
      //为了不让圆重叠需要的弧度
      var avatar_radian = Math.asin(this.avatar_size/big_r)*2 ;
      //上半部分的总弧度
      var top_radian = all_radian/2-avatar_radian/2 ;
      var top_avatar_radian = 3*avatar_radian ;
      //上半部分的第一个圆形到边缘的总弧度
      var top_border_radian = (top_radian - top_avatar_radian)/2;

      var avatar_box = [];
      //圆形到图片左边的距离
      var padding_center = 236/700*this.img_height+window.innerWidth/2-big_r/2;

      var remain_height = this.img_height/2;

      var pre_radian = 0;
      var current_radian = all_radian/2-top_border_radian;

      for(var index = 0;index<4;index++){
        var box = this.getAvatarBox(remain_height,big_r,pre_radian,current_radian,padding_center);
        avatar_box.push(box);
        remain_height = remain_height-box.height;
        pre_radian = current_radian;
        current_radian = current_radian-avatar_radian;
      }

      box = this.getAvatarBox(remain_height,big_r,pre_radian,avatar_radian/2,padding_center);
      avatar_box.push(box);
      remain_height = remain_height-box.height;

      avatar_box.push({'height':this.avatar_size,'padding':padding_center+big_r/2-this.avatar_size/2});
      console.log(padding_center+big_r/2-this.avatar_size/2-window.innerWidth/2)

      remain_height = 0;
      pre_radian = 0;
      var bottom_border_radian = (top_radian - 4*avatar_radian)/2;
      current_radian = bottom_border_radian;
      for(index = 0;index<6;index++){
        box = this.getBottomAvatarBox(remain_height,big_r,pre_radian,current_radian,padding_center);
        avatar_box.push(box);
        remain_height = remain_height+box.height;
        pre_radian = current_radian;
        current_radian += avatar_radian;
      }

      return avatar_box;
    }
  },
  methods: {
    onResize: function() {
      this.img_width = window.innerWidth
    }
  }
};
</script>
